import {
  Binoculars,
  Building,
  Database,
  File,
  Flows,
  Funnel,
  Health,
  MergeOrgs,
  OrgAnalysis,
  PuzzlePieces,
  Wrench,
  Plus,
} from '@sweep-io/sweep-design/dist/icons';

// Map icon names to their components
export const iconNameToIconComponent: Record<string, React.ComponentType> = {
  File,
  Health,
  Database,
  Flows,
  Wrench,
  PuzzlePieces,
  Funnel,
  MergeOrgs,
  Building,
  Binoculars,
  OrgAnalysis,
  Plus,
};
